export const HANDLE_SCROLL = "HANDLE_SCROLL";
export const HANDLE_SIDEBAR = "HANDLE_SIDEBAR";
export const FETCHING_ADD_DOWNLOAD = "FETCHING_ADD_DOWNLOAD";
export const FETCHING_EDIT_DOWNLOAD = "FETCHING_EDIT_DOWNLOAD";
export const FETCHING_REMOVE_DOWNLOAD = "FETCHING_REMOVE_DOWNLOAD";
